class TabCards extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];

    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.activateTab(tab));
      tab.addEventListener('keydown', event => this.onTabKeydown(event));
    });
  }

  activateTab(activeTab, moveFocus = false) {
    this.tabs.forEach(tab => {
      const selected = tab === activeTab;
      const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);

      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      panel?.classList.toggle('hidden', !selected);
      if (panel) panel.hidden = !selected;
    });

    if (moveFocus) activeTab.focus();
  }

  onTabKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (nextIndex === undefined) return;

    event.preventDefault();
    this.activateTab(this.tabs[nextIndex], true);
  }
}

if (!customElements.get('tab-cards')) customElements.define('tab-cards', TabCards);
